<template>
    <div>
        <!-- 轮播图 -->
        <div class="bannerModule">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item) in bannerList" :key="item.id">
                    <a :href="item.url">
                        <img :src="item.banner_url" alt="">
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>
        <van-tabs
        v-model="active" 
        color="#901d22cc"
        >
            <van-tab title="品牌">
                <!-- 品牌    -->
                <div class="brandModule">
                    <van-list
                    v-if="!brandNull"
                    v-model="loading.brand"
					:finished="finished.brand"
                    finished-text="没有更多了"
                    @load="pullUpLoading"
                    >
                        <brand :list="brandList"></brand>
                    </van-list>
                    <van-empty description="暂无数据" v-if="brandNull"/>
                </div>
            </van-tab>
            <van-tab title="器械">
                <div class="instrumentModule">
                    <van-list
                    v-if="!instrumentNull"
                    v-model="loading.instrument"
					:finished="finished.instrument"
                    finished-text="没有更多了"
                    @load="pullUpLoading"
                    >
                     <apparatus :list="instrumentList"></apparatus>
                    </van-list>
                    <van-empty description="暂无数据" v-if="instrumentNull"/>
                </div>
            </van-tab>
        </van-tabs>

    </div>
</template>
<script>
import Brand from './Components/Brand';
import Apparatus from './Components/apparatus';
import {InstClassesBanner,InstClassesBrands,InstClassesInstrument} from "../../config/interface.js"
export default {
    components:{
        Brand,
        Apparatus
    },
    data(){
        return{
            active:0,
            deviceclass_id:0,
            bannerList:[],      //轮播列表
            brandList:[],       //品牌列表
            instrumentList:[],  //器械列表
            brandPage:1,
            instrumentPage:1,
            limit:6,
            loading:{
                brand:false,
                instrument:false
            },
            finished:{
                brand:false,
                instrument:false
            },
            brandNull:false,
            instrumentNull:false

        }
    },
    computed:{
        deviceclass_id(){
            return this.$route.params.id;
        }
    },
    mounted(){
        this.getBanner();
        this.getBrand();
        this.getInstrument();
        document.title=this.$route.query.title;
    },
    methods:{
        //轮播图
        getBanner(){
 			const url=InstClassesBanner;
			let params={
				deviceclass_id:this.deviceclass_id
			}
			const method='POST';
			fetch(url,params,method)
			.then((res)=>{
				if(res.code==0){
                    let data=res.data;
                    this.bannerList=data;
                    
					// this.itemContent.isCollect=res.data.attach;
				}
			})
        },
        //上拉加载
        pullUpLoading(){
			setTimeout(() => {
			    this.active==0?this.brandPage++:this.instrumentPage++;
			    this.active==0?this.getBrand():this.getInstrument();
			}, 500);
        },
        //品牌
        getBrand(){
            const url=InstClassesBrands;
            // const url=MeetingHistory;
			let params={
                deviceclass_id:this.deviceclass_id,
                limit:this.limit,
				page:this.brandPage
            }
            const method='POST';
			fetch(url,params,method)
			.then((res)=>{
				if(res.code==0){
                    let data=res.data;
                    data.data.forEach((item,index)=>{
                        this.brandList.push(item);
                    })
                    this.loading.brand = false;
                    if(data.data.length<this.limit){
							this.finished.brand=true;
                    }
                    if(data.current_page==1&&data.data.length==0){
                        this.brandNull=true;
                    }
                    
				}
			})
        },
        //器械列表
        getInstrument(){
            const url=InstClassesInstrument;
            //  const url=MeetingRecent;
			let params={
                limit:this.limit,
				page:this.brandPage,
				deviceclass_id:this.deviceclass_id
            }
            const method='POST';
			fetch(url,params,method)
			.then((res)=>{
				if(res.code==0){
                    let data=res.data;
                     data.data.forEach((item,index)=>{
                        this.instrumentList.push(item);
                    })
                    this.loading.instrument = false;
                    if(data.data.length<this.limit){
						this.finished.instrument=true;
                    }
                    if(data.current_page==1&&data.data.length==0){
                        this.instrumentNull=true;
                    }
				}
			})
        },
        //点击轮播图
        clickBanner(){

        }
    }
}
</script>
<style lang="scss" scoped>
    .van-tabs{
        /deep/ .van-tabs__nav--card{
            margin:0px;
        }
    }
    .bannerModule{
        a{
            display: block;
        }
        img{
            width:100%;
            display:block;
        }
    }
    .brandModule,.instrumentModule{
        padding:14px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Instrument/classify.vue